import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=ebdba398&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordReset.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=ebdba398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdba398",
  null
  
)

export default component.exports